const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { saveLastVisitedView } from '@/lib/utils/loop-visualizations/lastVisitedVisualizationView';
const paramsSchema = z.object({
  dashboardId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/dashboard/$dashboardId/')({
  params: paramsSchema,
  beforeLoad: ({
    context: {
      flags
    },
    params: {
      org,
      loopId
    }
  }) => {
    if (!flags.visualizationsDashboardsEnabled) {
      throw redirect({
        to: '/org/$org/loop/$loopId/visualizations',
        params: {
          org,
          loopId
        },
        replace: true
      });
    }
  },
  loader: ({
    params
  }) => saveLastVisitedView(Number(params.loopId), {
    type: 'dashboard',
    id: Number(params.dashboardId)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});